import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { handleChangeCheckbox } from "@icarros/utils-react";
import { useState } from "react";
import { StyledSwitch, StyledInput, SwitchWrapper, SwitchDot, } from "./Switch.style";
const Switch = ({ name, initialState = false, isDisabled = false, autoFocus = false, id = name, onFocus = () => { }, onChange = () => { }, ...props }) => {
    const [isChecked, setIsChecked] = useState(initialState);
    const onInternalChange = (checked, name) => {
        if (!isDisabled) {
            setIsChecked(checked);
            onChange(checked, name);
        }
    };
    return (_jsx(SwitchWrapper, { children: _jsxs(StyledSwitch, { isDisabled: isDisabled, isChecked: isChecked, ...props, children: [_jsx(StyledInput, { id: id, name: name, type: "checkbox", checked: isChecked, onChange: (e) => handleChangeCheckbox(e, onInternalChange), autoFocus: autoFocus, onFocus: onFocus }), _jsx(SwitchDot, { isChecked: isChecked })] }) }));
};
export default Switch;
//# sourceMappingURL=Switch.js.map